// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment, SeedData } from "./environment.interface";

/**
 * 
 */
export const environment: IEnvironment = {
  production: false,

  sampleProperties: [
    ...SeedData.sampleProperties
  ],

  title: 'Rent to Retirement',
  env: 'dev',

  firebaseConfig: {
    apiKey: "AIzaSyD-Gf6kwHuoeTZjwqOfjvEtTOAbf_wRWro",
    authDomain: "dev-wealth-calculator.firebaseapp.com",
    projectId: "dev-wealth-calculator",
    storageBucket: "dev-wealth-calculator.appspot.com",
    messagingSenderId: "519034182238",
    appId: "1:519034182238:web:5468ca259354b4040472cf",
    measurementId: undefined
  }
};
